import React, { useState } from "react";
import "./Annoucement.css";
import AnnoucementImage from "../../../assets/images/sidebar_annoucement.png";
import AnnoucementImage2 from "../../../assets/images/Announcement_2.png";
import ComingSoon from "../../../assets/images/Wavy_Tech-08_Single-02.jpg";
import Role from "../../../interfaces/identity/Role";
import { ROLES } from "../../../Data/SD";

interface AnnoucementPagePropsType {
  currentRoles: Role[] | null;
}

const Annoucement = ({ currentRoles }: AnnoucementPagePropsType) => {

  const [showComingSoon, setShowComingSoon] = useState(false);

  return (
    <>
      {currentRoles &&
        currentRoles?.length > 0 &&
        currentRoles?.some((raw) => raw?.name === ROLES?.OWNER) ? (
        <div className="sidebar_annoucement owr_roles">
          <h3 className="anncmt_head">
            Welcome to <span className="text-[#7E57C2]">Waivera</span>
          </h3>
          <p className="anncmt_msg">
            Start the tour and discover how Waivera reveals your agency’s
            performance instantly, anytime, <br></br>anywhere
          </p>

          <button className="start_tour_btn own_stbtn"
            onClick={() => setShowComingSoon(true)}
          >Start Tour</button>
          <img
            src={AnnoucementImage}
            alt="Start Tour Now"
            className="own_anncmt_image "
          />
        </div>
      ) : (
        <div className="sidebar_annoucement oth_roles">
          <figure className="oth_anncmt_image px-4 mb-2">
            <img
              src={AnnoucementImage2}
              alt="Annoucement"
              className="w-100 h-100"
            />
          </figure>

          <h3 className="anncmt_head text-center">
            Welcome to <span className="text-[#7E57C2]">Waivera</span>
          </h3>
          <p className="anncmt_msg text-center">
            Get a quick walkthrough on monitoring your team, reviewing
            participant progress, and keeping tasks on track.
          </p>

          <div className="flex justify-center">
            <button className="start_tour_btn oth_stbtn"
              onClick={() => setShowComingSoon(true)}
            >Start Tour</button>
          </div>
        </div>
      )}

      {/* ================= Coming Soon Modal ================= */}
      {showComingSoon && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-[90%] max-w-md rounded-2xl bg-white p-6 text-center shadow-2xl
                          animate-[scaleIn_0.3s_ease-out]">

            <div className="flex justify-center">
              <img
                src={ComingSoon}
                alt="ComingSoon"
                className="w-80 h-80"
              />
            </div>

            <h2 className="mb-2 text-xl font-semibold text-[#7E57C2]">
              Coming Soon!
            </h2>

            <p className="mb-6 text-sm text-gray-600 leading-relaxed">
              The guided tour feature is currently under development.
              <br />
              We’re crafting something awesome for you!
            </p>

            <button
              onClick={() => setShowComingSoon(false)}
              className="rounded-lg bg-[#7E57C2] px-5 py-2 text-sm font-medium
                         text-white transition hover:bg-[#6a46b3]"
            >
              Got it
            </button>
          </div>
        </div>
      )}

      {/* Tailwind animation keyframe */}
      <style>
        {`
          @keyframes scaleIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </>
  );
};

export default Annoucement;
